import styled from 'styled-components';

export default styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	height: 80px;
	background: #000;
	padding-bottom: 30px;
	display: flex;
	align-items: center;
	justify-content: space-around;
	z-index: 10;
	.nav-item {
		flex: 1;
		align-items: center;
		justify-content: center;
		display: flex;
		padding: 15px 0;
		transition: opacity 200ms ease;
		opacity: 0.7;
		&.active {
			opacity: 1;
		}
	}
`;
